import { isInvalidMembershipNumber } from "../utils/common";
var validPreviousMembershipNumber = function validPreviousMembershipNumber(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "membership number";
  var error;
  var VARIANTS = {
    ARHI: "Only letters and numbers are allowed in ".concat(fileName, ".")
  };
  if (!value) {
    return error;
  }
  if (isInvalidMembershipNumber(value)) {
    error = VARIANTS[funnel] || VARIANTS.ARHI;
  }
  return error;
};
export default validPreviousMembershipNumber;